import * as Yup from 'yup';

import { PurchaseOrderItem, isPurchaseOrderProductItem } from '../../models/purchase-order-item';
import { fieldNames } from './models/purchase-order-positions-form-values';
import { isBlankPosition, withoutBlankPositions } from '../../../../common/components/palo/palo-first-position';

const positionSchema = Yup.object().shape({
    quantity: Yup.number()
        .moreThan(0, 'app.error.greaterZero')
        .typeError('app.error.required')
        .required('app.error.required'),
    price: Yup.number().typeError('app.error.required').required('app.error.required'),
    discount: Yup.number()
        .min(0, 'app.error.greaterZero')
        .max(100, 'app.error.lesserHundred')
        .typeError('app.error.required'),
});

export const positionsValidationSchema = Yup.object().shape({
    [fieldNames.allItems]: Yup.array()
        .of(
            // The blank first row waits for its article and is not saved (#2308).
            Yup.lazy(
                (item: PurchaseOrderItem) =>
                    isPurchaseOrderProductItem(item) && isBlankPosition(item) ? Yup.object() : positionSchema
                // HACK: type definition of Yup.lazy seems to be wrong
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ) as any
        )
        .required('app.error.required')
        .test(
            'one-position',
            'app.positions.error.needsOne',
            items => 0 < withoutBlankPositions((items ?? []) as PurchaseOrderItem[], isPurchaseOrderProductItem).length
        ),

    [fieldNames.netShippingCosts]: Yup.number().required('app.error.required').min(0, 'app.error.positive'),
    [fieldNames.netSurcharge]: Yup.number().required('app.error.required'),
});
